import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Typography,
  Card,
  Spin,
  Row,
  Col,
  DatePicker,
  Form,
  Checkbox,
} from "antd";

//PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TopContent from "../../../components/layouts/TopContent";
import appStatic from "../../../config/appStatic";
import appLabel from "../../../config/appLabel";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import definedApi from "../../../services/definedApi";

const AddGLA1100 = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { Text } = Typography;
  const { session } = userData;
  const { newProvisioningEntriesItems } = appStatic;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [createdJournalEntries, setCreatedJournalEntries] = useState(false);

  function onCancel() {
    navigate("/gla1100", { replace: false });
  }

  const onSubmit = (formValues) => {
    formValues.createjournalentries = createdJournalEntries;
    formValues.date = BOM.DateTime(formValues.date, "only-date");
    // console.log(formValues);return

    const body = {
      ...formValues,
      locale: "en",
      dateFormat: "dd MMMM yyyy",
      method: "POST",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, definedApi.NewProvisioningEntries, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, appLabel.newProvisioningEntriesMsg);
        navigate("/gla1100");
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const handleCreateJournalEntries = (e) => {
    setCreatedJournalEntries(e.target.checked);
  };

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={appLabel.newProvisioningEntries}
        pageItems={newProvisioningEntriesItems}
      />
      <Spin spinning={isLoading} size="large">
        <Form layout="vertical" style={{ paddingTop: 20 }} onFinish={onSubmit}>
          <Card
            headStyle={{ borderBottomWidth: 0 }}
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
            title={appLabel.provisioningEntriesSetup}
          >
            <Card
              style={{
                marginBottom: "2%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
            >
              <Row style={{ justifyContent: "space-between" }}>
                <Col span={12}>
                  <Form.Item
                    name="date"
                    label={
                      <Text style={{ fontSize: "16px" }}>
                        {appLabel.provisioningCriteria}
                      </Text>
                    }
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(),
                      },
                    ]}
                  >
                    <DatePicker style={{ width: "30vh" }} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name="createjournalentries">
                    <Checkbox onChange={(e) => handleCreateJournalEntries(e)}>
                      <Text style={{ fontSize: "16px" }}>
                        {appLabel.createJournalEntries}
                      </Text>
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>
            </Card>
            <Form.Item>
              <Row>
                {BOM.HasPermission("VIEW_ALL_PROVISIONING_ENTRIES") && (
                  <CustomButton
                    content="Submit"
                    style={{
                      width: "10%",
                      marginLeft: "auto",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    htmlType="submit"
                    backgroundColor="#15CCAE"
                    colorText="black"
                    hoverBackground="#4FECA0"
                  />
                )}
                <CustomButton
                  content="Cancel"
                  style={{
                    width: "10%",
                    marginLeft: "1%",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  backgroundColor="#fff"
                  colorText="black"
                  hoverBackground="#F5F5F5"
                  onClick={onCancel}
                />
              </Row>
            </Form.Item>
          </Card>
        </Form>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AddGLA1100);
